import { render, staticRenderFns } from "./ProblemSolutionCard.vue?vue&type=template&id=0c0dc5ae"
import script from "./ProblemSolutionCard.vue?vue&type=script&lang=js"
export * from "./ProblemSolutionCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports